
export const audios = [
    {
        name: 'Sinner',
        artist: 'Aaron Lewis',
        music: require('../../assets/audio/songs/Aaron Lewis - Sinner.mp3'),
        background: require('../../assets/images/songs-image/Sinner.jpg')
    },
    {
        name: 'Away in paradise',
        artist: '2Pac & Bob Marley',
        music: require('../../assets/audio/songs/2Pac Bob Marley - Away in paradise.mp3'),
        background: require('../../assets/images/songs-image/2PAC_BOB.jpg')
    },
    {
        name: 'Alors On Danse',
        artist: 'Stromae',
        music: require('../../assets/audio/songs/Stromae Alors.mp3'),
        background: require('../../assets/images/songs-image/stromae.jpg')
    },
    {
        name: 'remix',
        artist: '2pac',
        music: require('../../assets/audio/songs/2pac-remix.mp3'),
        background: require('../../assets/images/songs-image/2pac.jpg')
    },
    {
        name: 'One More Light',
        artist: 'Linkin Park',
        music: require('../../assets/audio/songs/Linkin Park - One More Light.mp3'),
        background: require('../../assets/images/songs-image/linkin_park.jpg')
    },
    {
        name: 'Gemini',
        artist: 'Princess Nokia',
        music: require('../../assets/audio/songs/Nokia - Gemini.mp3'),
        background: require('../../assets/images/songs-image/princess_nokia.jpg')
    },
    {
        name: 'AERIALS',
        artist: 'SYSTEM OF A DOWN',
        music: require('../../assets/audio/songs/SYSTEM - AERIALS.mp3'),
        background: require('../../assets/images/songs-image/system.jpg')
    },
    {
        name: 'Calabria',
        artist: 'Enur feat Natasja',
        music: require('../../assets/audio/songs/Calabria.mp3'),
        background: require('../../assets/images/songs-image/Calabria.jpg')
    },
    {
        name: 'I Am Loco',
        artist: 'ILL NINO',
        music: require('../../assets/audio/songs/I Am Loco.mp3'),
        background: require('../../assets/images/songs-image/ill_nino.jpg')
    }
]

